import { CheckCircle2 } from 'lucide-react';
import { cn } from '@/lib/utils';
import type { PlanProgressStageState } from '@/types/planBuildProgress';

interface PlanProgressStageRowProps {
  description: string;
  state: PlanProgressStageState;
}

function AnimatedDots() {
  return (
    <span className="inline-flex gap-0.5" aria-hidden>
      <span className="w-1.5 h-1.5 rounded-full bg-muted-foreground animate-pulse" />
      <span className="w-1.5 h-1.5 rounded-full bg-muted-foreground animate-pulse [animation-delay:0.15s]" />
      <span className="w-1.5 h-1.5 rounded-full bg-muted-foreground animate-pulse [animation-delay:0.3s]" />
    </span>
  );
}

/**
 * Single stage row: description + IN_PROGRESS (dots) or DONE (check).
 * Truthful state from backend; no timers.
 */
export function PlanProgressStageRow({ description, state }: PlanProgressStageRowProps) {
  return (
    <li
      className={cn(
        'flex items-center gap-3 text-sm',
        state === 'IN_PROGRESS' && 'font-medium',
        state === 'PENDING' && 'text-muted-foreground'
      )}
      aria-busy={state === 'IN_PROGRESS'}
    >
      <span className="flex items-center justify-center shrink-0 w-5" aria-hidden>
        {state === 'IN_PROGRESS' && <AnimatedDots />}
        {state === 'DONE' && <CheckCircle2 className="h-4 w-4 text-load-fresh" />}
        {state === 'PENDING' && (
          <span className="h-4 w-4 rounded-full border-2 border-muted-foreground/30" />
        )}
      </span>
      <span
        className={cn(
          'text-foreground',
          state === 'PENDING' && 'text-muted-foreground'
        )}
      >
        {description}
      </span>
    </li>
  );
}
